function MoreOptionHorizontal({ size = '18', style = {}}) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="0 0 18 3"
      fill="none"
    >
      <ellipse
        cx="16.5"
        cy="1.5"
        rx="1.5"
        ry="1.5"
        transform="rotate(90 16.5 1.5)"
        fill="#20293C"
      />
      <circle
        cx="9"
        cy="1.5"
        r="1.5"
        transform="rotate(90 9 1.5)"
        fill="#20293C"
      />
      <ellipse
        cx="9"
        cy="1.5"
        rx="1.5"
        ry="1.5"
        transform="rotate(90 9 1.5)"
        fill="#20293C"
      />
      <circle
        cx="1.5"
        cy="1.5"
        r="1.5"
        transform="rotate(90 1.5 1.5)"
        fill="#20293C"
      />
    </svg>
  );
}

export default MoreOptionHorizontal;
